import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ContextService } from 'app/core/services';
import { ApiResponse, LocationType, SiteLocation } from 'app/shared/types';
import { environment } from 'environment/environment';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { FeatureFlags } from './feature-flags';

@Injectable({
  providedIn: 'root',
})
export class LocationTypesService extends BaseApiService<
  ApiResponse<{ locationTypes: LocationType[] }>,
  ApiResponse<{ locationType: LocationType }>,
  ApiResponse<{ id: string }>
> {
  private contextService = inject(ContextService);

  constructor(public override http: HttpClient) {
    super(http, environment.siteManagementApiBaseUrl);
  }

  private get isFeatureFlagEnabled(): boolean {
    return this.contextService.isFeatureFlagEnabled(FeatureFlags.LocationsHierarchy);
  }

  public override controllerName(): string {
    return `api/location-types`;
  }

  public getSiteLocationById(id: string): Observable<ApiResponse<{ location: SiteLocation }>> {
    const params = new HttpParams();

    if (this.isFeatureFlagEnabled) {
      params.set('api-version', '2.0');
    }

    return this.http.get<ApiResponse<{ location: SiteLocation }>>(
      `${this.api}/api/sites/${this.contextService.siteId.value}/locations/${id}`,
      {
        params,
      },
    );
  }
}
